import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=4b623fa8&scoped=true&lang=pug&"
import script from "./Top.vue?vue&type=script&lang=ts&"
export * from "./Top.vue?vue&type=script&lang=ts&"
import style0 from "./Top.vue?vue&type=style&index=0&id=4b623fa8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b623fa8",
  null
  
)

component.options.__file = "Top.vue"
export default component.exports